// A genuine child popup (Map/Units/Chat/Call History) is opened by AppShell
// with a `wc_`-prefixed window name. A window merely opened by another window
// (e.g. the Tenant Management one-click login opening the dispatch app) has an
// opener too, but is a full main window and must keep its menu/chrome.
export function isChildPopup(): boolean {
  return typeof window !== 'undefined'
    && window.opener !== null
    && /^wc_/.test(window.name || '');
}
